import { getReducerErrorMessage, getReducerResponsePayload } from 'src/utils/helpers'

const initialState = {
  selectedPaymentPolicies: [],
  paymentPoliciesTimestamp: 0,
  paymentPolicies: [],
  policiesBillingType: null,
  customNoPaymentOptionsLabel: null,
  isEPayPolicy: false,
  isETransfer: false,
  eTransferEmail: null,
  eTransferSecret: null,
  loadingPaymentOptions: false,
  getPaymentOptionsResponse: {},
  isETransferEmailInProgress: false,
  sendETransferEmailResponse: {},
  submitPayment: false,
  paymentSuccessful: false,
  isEPayPaymentInformationInProgress: false,
  submitEPayPaymentInformationResponse: {},
  ePayPaymentInformationPayload: {},
  isProcessEPayInProgress: false,
  processEPayPaymentResponse: {},
  processEPayPaymentPayload: {},
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_PAYMENTS_STATE': {
      return initialState
    }

    /**
     *
     * TODO: PAT-1574 Remove this when "Stripe" is removed
     *
     * @deprecated
     */
    case 'GET_POLICIES': {
      return {
        ...state,
        loadingPolicies: true,
      }
    }
    case 'GET_POLICIES_COMMIT': {
      return {
        ...state,
        loadingPolicies: false,
        policies: action.payload,
      }
    }
    case 'GET_POLICIES_ROLLBACK': {
      return {
        ...state,
        loadingPolicies: false,
      }
    }

    /**
     *
     * TODO: PAT-1574 Remove this when "Stripe" is removed
     *
     * @deprecated
     */
    case 'GET_PAYMENT_POLICIES': {
      return {
        ...state,
        loadingPaymentPolicies: true,
      }
    }
    case 'GET_PAYMENT_POLICIES_COMMIT': {
      return {
        ...state,
        loadingPaymentPolicies: false,
        paymentPolicies: action.payload,
      }
    }
    case 'GET_PAYMENT_POLICIES_ROLLBACK': {
      return {
        ...state,
        loadingPaymentPolicies: false,
      }
    }

    case 'SET_SELECTED_PAYMENT_POLICIES': {
      return {
        ...state,
        selectedPaymentPolicies: action.payload.selectedPaymentPolicies,
      }
    }

    case 'GET_PAYMENT_OPTIONS': {
      return {
        ...state,
        paymentPoliciesTimestamp: 0,
        loadingPaymentOptions: true,
        getPaymentOptionsResponse: {},
      }
    }
    case 'GET_PAYMENT_OPTIONS_COMMIT': {
      return {
        ...state,
        paymentPoliciesTimestamp: new Date().getTime(),
        paymentPolicies: action.payload.policies,
        policiesBillingType: action.payload.policiesBillingType,
        customNoPaymentOptionsLabel: action.payload.customNoPaymentOptionsLabel,
        isEPayPolicy: action.payload.isEPayPolicy,
        isETransfer: action.payload.isETransfer,
        eTransferEmail: action.payload.eTransferEmail,
        eTransferSecret: action.payload.eTransferSecret,
        loadingPaymentOptions: false,
        getPaymentOptionsResponse: {
          success: true,
        },
      }
    }
    case 'GET_PAYMENT_OPTIONS_ROLLBACK': {
      return {
        ...state,
        paymentPoliciesTimestamp: 0,
        loadingPaymentOptions: false,
        getPaymentOptionsResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'SEND_E_TRANSFER_EMAIL': {
      return {
        ...state,
        isETransferEmailInProgress: true,
        sendETransferEmailResponse: {},
      }
    }
    case 'SEND_E_TRANSFER_EMAIL_COMMIT': {
      return {
        ...state,
        isETransferEmailInProgress: false,
        sendETransferEmailResponse: {
          success: true,
        },
        selectedPaymentPolicies: [],
      }
    }
    case 'SEND_E_TRANSFER_EMAIL_ROLLBACK': {
      return {
        ...state,
        isETransferEmailInProgress: false,
        sendETransferEmailResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'SUBMIT_E_PAY_PAYMENT_INFORMATION': {
      return {
        ...state,
        isEPayPaymentInformationInProgress: true,
        submitEPayPaymentInformationResponse: {},
      }
    }
    case 'SUBMIT_E_PAY_PAYMENT_INFORMATION_COMMIT': {
      return {
        ...state,
        isEPayPaymentInformationInProgress: false,
        submitEPayPaymentInformationResponse: {
          success: true,
        },
        ePayPaymentInformationPayload: action.payload,
      }
    }
    case 'SUBMIT_E_PAY_PAYMENT_INFORMATION_ROLLBACK': {
      return {
        ...state,
        isEPayPaymentInformationInProgress: false,
        submitEPayPaymentInformationResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    case 'PROCESS_E_PAY_PAYMENT': {
      return {
        ...state,
        isProcessEPayInProgress: true,
        processEPayPaymentResponse: {},
      }
    }
    case 'PROCESS_E_PAY_PAYMENT_COMMIT': {
      return {
        ...state,
        isProcessEPayInProgress: false,
        processEPayPaymentResponse: {
          success: true,
        },
        processEPayPaymentPayload: action.payload,
      }
    }
    case 'PROCESS_E_PAY_PAYMENT_ROLLBACK': {
      return {
        ...state,
        isProcessEPayInProgress: false,
        processEPayPaymentResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
        processEPayPaymentPayload: getReducerResponsePayload(action),
      }
    }

    /**
     *
     * TODO: PAT-1574 Remove Stripe code
     *
     * @deprecated
     */
    case 'MAKE_PAYMENT': {
      return {
        ...state,
        submitPayment: true,
      }
    }
    case 'MAKE_PAYMENT_COMMIT': {
      return {
        ...state,
        submitPayment: false,
        paymentSuccessful: true,
      }
    }
    case 'MAKE_PAYMENT_ROLLBACK': {
      return {
        ...state,
        submitPayment: false,
        paymentSuccessful: false,
      }
    }

    default: {
      return state
    }
  }
}
